const formatNumber = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "--";
  return num.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

const formatSignedNumber = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "--";
  const prefix = num > 0 ? "+" : "";
  return `${prefix}${formatNumber(num)}`;
};

const formatPercent = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "--";
  const prefix = num > 0 ? "+" : "";
  return `${prefix}${num.toFixed(2)}%`;
};

export const buildMarketOverviewCards = (response = {}) => {
  const rows = Array.isArray(response?.data) ? response.data : [];

  return rows.map((item, index) => {
    const changeIsPositive = Number(item.net_change) >= 0;

    return {
      id: `${item.exchange || "NA"}-${item.tradingsymbol || index}-${index}`,
      title: item.tradingsymbol || "--",
      value: formatNumber(item.last_price),
      change: formatSignedNumber(item.net_change),
      changePercent: formatPercent(item.pct_change),
      changeIsPositive,
      lastTradeTime: item.last_trade_time,
    };
  });
};
